<template>
  <group-card title="Emails" icon="mail">
    <div class="table-container">
      <table class="data-table wide">
        <thead>
          <tr>
            <th>Time</th>
            <th>User</th>
            <th>Subject</th>
            <th>Type</th>
            <th>Content</th>
            <th>Attachments</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="log in joinedLogs">
            <td>{{ (log.created_at ? log.created_at : Date()) | datetime }}</td>
            <td>{{ log.created_by }}</td>
            <td>{{ log.subject }}</td>
            <td>{{ log.type }}</td>
            <td>
              <v-btn
                v-if="log.content !== null
                  && log.content !== undefined
                  && log.content !== ''"
                color="#005596"
                outlined
                small
                @click="showEmailMessage(log.content)">See message
              </v-btn>
              <v-btn
                v-else
                disabled
                outlined
                small
              >Does not exist</v-btn>
            </td>
            <td>
              <span v-for="(attachment, index) in log.attachments">
                <a :href="attachment.path" target="_blank" @click="handleAttachmentClick($event, attachment.path)">
                  Attachment№{{ index + 1 }}
                </a>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </group-card>
</template>
<script>
import GroupCard from '@/components/Cards/GroupCard';
import filters from "@/components/utils/filters";
import {mapGetters} from 'vuex';
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
export default {
  components: {
    GroupCard,
  },
  data() {
    return {
      joinedLogs: [],
    }
  },
  filters: {
    ...filters,
  },
  watch: {
    async application() {
      this.getEmailLog();
    }
  },
  methods: {
    showEmailMessage(content) {
      this.$modal.show(ConfirmDialog, {
        title: 'Message',
        message: content,
        confirmText: 'Ok',
      });
    },
    showAttachmentMessage() {
      this.$modal.show(ConfirmDialog, {
        title: 'Warning',
        message: 'This attachment is not available from Zink - contact support to have it restored if this was in error',
        confirmText: 'Ok',
      });
    },
    async getEmailLog() {
      if (this.application !== null) {
        let emailAuditLogs = await this.$store.dispatch("get_email_audit_logs", this.application.loan.id);
        let smsAuditLogs = await this.$store.dispatch("get_sms_audit_logs", this.application.loan.id);
        this.joinedLogs  = emailAuditLogs.concat(smsAuditLogs);
        this.joinedLogs.sort((a, b) => { return Date.parse(b.created_at) - Date.parse(a.created_at);});
      }
    },
    isValidPath(path) {
      return /^https?:\/\//.test(path);
    },
    handleAttachmentClick(event, path) {
    if (!this.isValidPath(path)) {
        // Prevent the default action of the link (opening the link)
        event.preventDefault();
        // If the path is not valid, show the attachment warning message
        this.showAttachmentMessage();
        // Prevent the default action of the link (i.e., opening the link)
        return false;
      }
      // If the path is valid, allow the default action to proceed (opening the link)
      return true;
    },
  },
  computed: {
    ...mapGetters([
      "application",
    ]),
  },
  created() {
    this.getEmailLog();
  },
};
</script>
<style scoped lang="scss">
</style>

